<template>
    <TimelineComponent :dailyBasis="true" :captainId="2" />
</template>

<script>
import TimelineComponent from '@/components/Timeline.vue';

export default {
  name: 'CaptainStatusesTimeline',
  components: {
    TimelineComponent
  }
}
</script>